<div [class]="field.className" [ngClass]="widthClass">
  <mat-form-field [appearance]="props.appearance" class="wrapper-class" #form>
    <mat-label>{{ props.label }}</mat-label>
    <input
      matInput
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
      [placeholder]="props.label"
      [value]="field.defaultValue"
    />
    <div
      class="mat-form-field-hint-wrapper"
      [ngClass]="{ 'hint-width': isWidthRequired }"
    >
      <div
        class="tooltip"
        *ngIf="
        showErrMessage(field);
          else hint_field
        "
      >
        <mat-error>
          <span class="error-message">
            <formly-validation-message
              [field]="field"
            ></formly-validation-message>
          </span>
        </mat-error>
      </div>
      <ng-template #hint_field>
        <div *ngIf="isHtml">
          <mat-hint [innerHtml]="props.description"></mat-hint>
        </div>
        <div *ngIf="!isHtml">
          <mat-hint [innerText]="props.description"></mat-hint>
        </div>
      </ng-template>
    </div>
  </mat-form-field>
</div>